<script>
export default {
    name: "AccountModal",
    props: {
        accounts: {
            type: Array,
            required: true,
        },
        selectedAccount: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            filter: "",
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50],
        };
    },
    computed: {
        filtered() {
            let data = this.accounts;
            var total = this.currentPage * this.perPage;
            if (this.filter.trim() != "" && this.filter) {
                data = data.filter((item) => {
                    return item.accountName
                        .toUpperCase()
                        .includes(this.filter.toUpperCase()) || 
                        item.uacs.toUpperCase().includes(this.filter.toUpperCase()) || 
                        item.uacs.replace(/\s/g, '').toUpperCase().includes(this.filter.toUpperCase());
                });
            }
            var currentData = data.slice(total - this.perPage, total);
            if (this.currentPage > 1 && currentData.length == 0) {
                total = (this.currentPage - 1) * this.perPage;
                currentData = data.slice(total - this.perPage, total);
            }
            return currentData;
        },
        rows() {
            let data = this.accounts;
            if (this.filter.trim() != "" && this.filter) {
                data = data.filter((item) => {
                    return item.accountName
                        .toUpperCase()
                        .includes(this.filter.toUpperCase()) || 
                        item.uacs.toUpperCase().includes(this.filter.toUpperCase()) || 
                        item.uacs.replace(/\s/g, '').toUpperCase().includes(this.filter.toUpperCase());
                });
            }
            return data.length;
        },
    },
    methods: {
        selectAccount(account) {
            this.$emit("select-account", account);
            this.$bvModal.hide("search-account-modal");
        },
    },
};
</script>
<template>
    <b-modal id="search-account-modal" title="Select Account" hide-footer>
      <div class="row">
        <div class="col-md-12 d-flex">
            <div
                id="tickets-table_filter"
                class="dataTables_filter me-1"
            >
                <label
                    class="
                        d-inline-flex
                        align-items-center
                    "
                >
                    <b-form-input
                        autocomplete="off"
                        v-model="filter"
                        type="search"
                        placeholder="Search Items..."
                        class="form-control form-control-sm"
                    ></b-form-input>
                </label>
            </div>
            <div
                id="tickets-table_length"
                class="dataTables_length"
            >
                <label
                    class="
                        d-inline-flex
                        align-items-center
                        mb-0
                    "
                >
                    <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select>
                </label>
            </div>
        </div>
      </div>
      <table class="table table-bordered table-striped">
        <thead>
          <tr>
            <th>UACS</th>
            <th>Account Name</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="account in filtered" :key="account.id" @click="selectAccount(account)" class="cursor-pointer">
            <td>{{ account.uacs }}</td>
            <td>{{ account.accountName }}</td>
          </tr>
        </tbody>
      </table>
      <div class="row">
        <div class="col">
            <div
                class="dataTables_paginate paging_simple_numbers float-end"
            >
                <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                    ></b-pagination>
                </ul>
            </div>
        </div>
    </div>
    </b-modal>
</template>